import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WorkspaceSidebarComponent } from '../../components/sidebars/workspace-sidebar/workspace-sidebar.component';
import { Drawer } from 'primeng/drawer';
import { NotificationBarComponent } from '../../components/notification-bar/notification-bar.component';
import { ToolbarComponent } from '../../components/toolbar/toolbar.component';

@Component({
  selector: 'dt-workspace-layout',
  imports: [
    RouterOutlet,
    WorkspaceSidebarComponent,
    Drawer,
    NotificationBarComponent,
    ToolbarComponent,
  ],
  templateUrl: './workspace-layout.component.html',
  styleUrl: './workspace-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceLayoutComponent {
  drawerVisible = signal(false);
}
